import { Popover } from "ui/popover/popover";
import { QuickTipPanel } from "ui/quick-tip/quick-tip-panel";
import { type QuickTipProps } from "ui/quick-tip/quick-tip.types";

/**
 * `onClose` goes to the `Panel`'s close button only, never to the `Popover`: there it would also fire on
 * an outside click or `Escape`, and a call site that dismisses its guide for good from `onClose` would
 * lose the tip to any stray click.
 */
export const QuickTip = ({
  title,
  body,
  showIcon,
  onClose,
  onConfirm,
  confirmLabel,
  arrow = true,
  placement = "bottom-start",
  ...rest
}: QuickTipProps) => (
  <Popover
    {...rest}
    arrow={arrow}
    placement={placement}
    keepPageInteractive
    disableAutoFocus
    padding={0}>
    <QuickTipPanel
      title={title}
      body={body}
      showIcon={showIcon}
      onClose={onClose}
      onConfirm={onConfirm}
      confirmLabel={confirmLabel}
    />
  </Popover>
);
